import React, { useState } from "react";
import PanelTemplate from "../../templates/Panel";
import ModalGenerateMockup from "../Quote/ModalProduct/ModalGenerateMockup";
import PlanFeatureUpgradeModal from "../../components/PlanFeatureUpgradeModal";
import { canUseProductMock } from "../../services/auth";
import "./styles.scss";

const svgProps = {
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
};

const TOOL_ICONS = {
    mockup: (
        <svg {...svgProps}>
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <path d="M21 15l-5-5L5 21" />
        </svg>
    ),
    soon: (
        <svg {...svgProps}>
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
        </svg>
    ),
};

const ToolsList = () => {
    const [openTool, setOpenTool] = useState(null);
    const [upgradeFeature, setUpgradeFeature] = useState(null);

    const tools = [
        {
            key: 'mockup',
            label: 'Gerador de mockup',
            description: 'Aplique o logo do cliente em qualquer foto de produto e baixe a amostra pronta.',
            color: '#362B7A',
            bg: '#EEEDFE',
            show: true,
            // Sem o recurso no plano o card continua na tela: é ele que conta
            // que a ferramenta existe.
            locked: !canUseProductMock(),
            feature: 'product_mock',
        },
    ].filter((tool) => tool.show);

    return (
        <PanelTemplate id="tools-list">
            <div className="tools-page">
                <h1>Ferramentas</h1>
                <h3>Recursos avulsos do dia a dia comercial, fora do fluxo de orçamento.</h3>

                <div className="tools-grid">
                    {tools.map((tool) => (
                        <button
                            key={tool.key}
                            type="button"
                            className={`tool-card${tool.locked ? ' tool-card--locked' : ''}`}
                            onClick={() => tool.locked ? setUpgradeFeature(tool.feature) : setOpenTool(tool.key)}
                        >
                            <span
                                className="tool-card__icon"
                                style={{ background: tool.bg, color: tool.color }}
                            >
                                {TOOL_ICONS[tool.key]}
                            </span>
                            <span className="tool-card__text">
                                <span className="tool-card__label">
                                    {tool.label}
                                    {tool.locked && <span className="tool-card__lock">🔒</span>}
                                </span>
                                <span className="tool-card__meta">{tool.description}</span>
                            </span>
                        </button>
                    ))}

                    <div className="tool-card tool-card--soon">
                        <span className="tool-card__icon">{TOOL_ICONS.soon}</span>
                        <span className="tool-card__text">
                            <span className="tool-card__label">Em breve</span>
                            <span className="tool-card__meta">
                                Novas ferramentas para deixar sua operação ainda mais eficiente.
                            </span>
                        </span>
                    </div>
                </div>
            </div>

            <ModalGenerateMockup
                show={openTool === 'mockup'}
                close={() => setOpenTool(null)}
                chooseSource
            />

            <PlanFeatureUpgradeModal
                feature={upgradeFeature}
                show={upgradeFeature !== null}
                close={() => setUpgradeFeature(null)}
            />
        </PanelTemplate>
    );
};

export default ToolsList;
